import Config from '../../config';
import Grid from '../../view/grid';
import RefBooksModule from './refbooks.module';
import Organizations from '../../collection/organizations';

import { roleC } from '../../roles';
import { hashify } from '../../utils/arrays';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { beginLock, endLock } from '../../loader';





const 
    OPEN_TYPE = 'type-form--popup';





export default RefBooksModule.extend( {

    template: 'module/refbooks/types.form',

    url() {
        return this.options.type.id
            ? `types/${this.options.type.id}/edit`
            : `types/new`;
    },

    open(type) {
        this.options.type = type, this.options.original = type.clone();
        if (!type.id)
            if (this.state().cluster && this.state().cluster.id != -1)
                type.set( 'cluster', this.state().cluster );
            else if (~roleC.indexOf( Config.role() ))
                type.set( 'cluster', Config.cluster() );

        const clusters = hashify( this.options.clusters, cl => [cl.id, cl] );
        this.options.sorted = new Organizations();
        this.options.filtered = new Organizations();
        this.options.resulted = new Organizations();
        this.options.organizations = new Organizations( this.options.organizations
            .toJSON()
            .map( ({ cluster_id, ...attrs }) => ({
                ...attrs,
                cluster: clusters[cluster_id]
            }) ) );

        const { organizations, sorted, } = this.options;
        return Grid.sort( this.state(), organizations, sorted )
            .then( () => reRenderGrid.call( this ) )
            .then( () => this.bind( type ) );
    },

    start() {
        this.listenTo( this.options.type, 'change:cluster', () => {
            this.setState( { page: 1, } ), this.navigated();
            reRenderGrid.call( this );

            const { type } = this.options;
            if (!type.get( 'group_id' ))
                return;

            const cluster = type.get( 'cluster' );
            const [typeGroup] = this.options.typeGroups.toJSON()
                    .filter( tg => tg.id == type.get( 'group_id' ) );

            if (!!cluster !== !!typeGroup.cluster)
                this.model.set( 'group_id', null );

            if (typeGroup.cluster)
                if (typeGroup.cluster.id != cluster.id)
                    this.model.set( 'group_id', null );
        } );
        this.listenTo( this.options.type, 'change',
            () => this.$( '.-save' )[0].disabled = !this.hasDiff() );
        this.listenTo( this.options.type, 'change:default_type',
            () => this.OrgGrid.enable( this.model.get( 'default_type' ) === 'f' ) );

        return this;
    },

    stop() {
        return this.stopListening( this.options.type ), this;
    },

    serialize() {
        const { sort, direction, search: searchString, } = this.state();
        const { filtered, resulted, } = this.options;
        const { typeGroups, clusters, } = this.options;

        const typeGroupsFn = () => typeGroups
            .toJSON()
            .filter( tg => !tg.cluster && !this.model.get( 'cluster' ) ||
                tg.cluster && this.model.get( 'cluster' ) &&
                    this.model.get( 'cluster' ).id == tg.cluster.id )
            .map( tg => ({ id: tg.id, title: tg.name }) );

        return {
            typeGroupsFn, clusters,
            organizations: filtered,
            rows: resulted,
            searchString, sort, direction,
            hasDiff: this.hasDiff(),
        };
    },

    diff(options = {}) {
        const { type, original } = this.options;
        return type.diff( original, options );
    },

    hasDiff(options = {}) {
        return this.diff( options ).length > 0;
    },

    events: {

        'click .-save'() {
            // cluster may be set only at create
            if (!this.model.id)
                if (this.model.get( 'cluster' )) {
                    const clusterId = this.model.get( 'cluster' ).id;
                    const clusterIds = hashify( this.options.organizations,
                        org => [org.id, org.cluster.id] );

                    this.model.set( 'departments', this.model.get( 'departments' )
                        .filter( orgId => clusterId == clusterIds[orgId] ) );
                }

            beginLock( this );

            return this.options.types.save( this ).then( 

                (/*type*/) => this.trigger( RefBooksModule.BACK ), 

                message => {
                    endLock( this );
                    handle( this, error( message ) );
                } );
        },

        'click .-close'() {
            this.trigger( RefBooksModule.BACK );
        },

        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;

            return this.setState( { page: 1, sort, direction, } ),
                Grid.sort( this.state(), this.options.organizations, this.options.sorted, )
                    .then( () => reRenderGrid.call( this ) )
                    // hack: to rerender grid caption with order direction
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

        'click .-toggle-binding'({currentTarget}) {
            const { id } = currentTarget.dataset;
            const { type, filtered, } = this.options;

            const needAppend = currentTarget.checked;
            const oldOrganizations = type.get( 'departments' );
            const newOrganizations = needAppend
                ? [...oldOrganizations, id]
                : oldOrganizations.filter( itemId => itemId != id );

            type.set( 'departments', newOrganizations );

            const ids = hashify( newOrganizations );
            this.$( '.-toggle-all' )[0].checked = filtered.every( org => ids[org.id] );
        },

        'click .-toggle-all'({currentTarget}) {
            const value = currentTarget.checked;
            const { type, filtered } = this.options;

            const ids = filtered.models.map( item => item.id );
            const h = hashify( ids );
            const drained = type.get( 'departments' )
                .filter( id => !h[id] );

            type.set( 'departments', value
                ? [...drained, ...ids]
                : [...drained] );

            this.$( '.-toggle-binding' ).prop( 'checked', value );
        }

    },

    [RefBooksModule.event( 'Paging:page')](page) {
        return this.setState( { page: +page, } ),
            reRenderGrid.call( this ),
            this.navigated();
    },

    [RefBooksModule.event( 'Search:search')](search) {
        return this.setState( { search, page: 1, } ), 
            reRenderGrid.call( this ),
            this.navigated();
    },

}, {

    OPEN_TYPE,

} );





function reRenderGrid() {
    const { type, sorted, filtered, resulted } = this.options;
    filter( this.state(), type, sorted, filtered, resulted );
}

function filter({ search, page, limit }, type, source, filtered, dest) {
    const searchString = search.toLowerCase();
    const cluster = type.get( 'cluster' );

    const models = source.toJSON()
        .filter( model =>
            !cluster || model.cluster.id == cluster.id )
        .filter( model => ~(model.id + '').indexOf( searchString )
            || ~model.name.toLowerCase().indexOf( searchString ) );

    dest.total = filtered.total = models.length;
    dest.page = filtered.page = page;
    dest.limit = filtered.limit = limit;
    
    filtered.reset( models );
    dest.reset( models
        .filter( (_, index) => index >= limit * (page - 1) &&
                               index <  limit * page ) );
}


// WEBPACK FOOTER //
// ./src/js/module/refbooks/types.form.js